import { render, staticRenderFns } from "./Conference.vue?vue&type=template&id=653c1a12&scoped=true&"
import script from "./Conference.vue?vue&type=script&lang=js&"
export * from "./Conference.vue?vue&type=script&lang=js&"
import style0 from "./Conference.vue?vue&type=style&index=0&id=653c1a12&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "653c1a12",
  null
  
)

export default component.exports